export default __webpack_public_path__ + "static/media/preview.72be54e0.svg";